import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';
import s from './ContentWrapper.module.scss';

type ContentWrapperType = {
  open?: boolean;
  collapsed?: boolean;
  container?: boolean;
  containerWidth?: number;
  vAlignMiddle?: boolean;
  columnDirection?: boolean;
  noScroll?: boolean;
  backgroundColor?: string;
  padding?: string;
};

export const ContentWrapper: FC<PropsWithChildren<ContentWrapperType>> = ({
  children,
  open,
  collapsed,
  container,
  containerWidth,
  vAlignMiddle,
  columnDirection,
  noScroll,
  backgroundColor,
  padding,
}) => {
  const content = container ? (
    <div
      className={classNames(s.contentWrapperContainer, {
        [s.vAlignMiddle]: vAlignMiddle,
        [s.columnDirection]: columnDirection,
      })}
      style={containerWidth ? { maxWidth: containerWidth } : {}}
    >
      {children}
    </div>
  ) : (
    children
  );

  return (
    <div
      className={classNames(s.drawerWrapper, {
        [s.open]: open,
      })}
    >
      <div
        className={classNames(s.contentWrapper, {
          [s.collapsed]: collapsed,
          [s.noScroll]: noScroll,
          [s.greyBackgroundColor]: backgroundColor === 'grey',
        })}
        data-page-variant={backgroundColor === 'grey' ? 'light' : backgroundColor === 'white' ? 'white' : undefined}
        style={padding ? { padding: padding } : {}}
      >
        {content}
      </div>
    </div>
  );
};
